// src/components/guides/QuickGuideButton.jsx
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lightbulb, X } from 'lucide-react';
import RelationshipCompassQuickGuideHub from './RelationshipCompassQuickGuideHub';

const QuickGuideButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  // The Coach page has a message bar fixed along the bottom: sit above it.
  const { pathname } = useLocation();
  const position = pathname === '/coach' ? 'bottom-24' : 'bottom-8';

  return (
    <>
      {/* Floating Action Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(true)}
        className={`fixed ${position} left-8 w-14 h-14 bg-gradient-to-br from-rose-500 to-pink-500 rounded-full shadow-lg flex items-center justify-center z-30 group`}
        aria-label="Open Relationship Guide"
      >
        <Lightbulb className="w-6 h-6 text-white" />

        {/* Pulse animation */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75 animate-ping pointer-events-none"></span>

        {/* Tooltip */}
        <span className="absolute left-16 px-3 py-1 bg-slate-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          Relationship Guide
        </span>
      </motion.button>

      {/* Quick Guide Panel */}
      <RelationshipCompassQuickGuideHub isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default QuickGuideButton;